export function selectedcompanydata(state = {}, action) {
    switch (action.type) {
    case 'COMPANY DATA':
        console.log(action.data);
        return action.data;
    default:
        return state;
    }
}
